import { Chart } from './Chart'
import type { ApexOptions } from 'apexcharts'

class HeatmapChart extends Chart {
  options = {
    ...this.options,
    chart: {
      ...this.options.chart,
      type: 'heatmap',
      height: 500,
      zoom: {
        enabled: false
      }
    },
    tooltip: {
      followCursor: true
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: '12px',
      markers: {
        width: 0
      },
      itemMargin: {
        horizontal: 0,
        vertical: 0
      },
      formatter: function (seriesName, opts) {
        const range = opts.w.config.plotOptions.heatmap.colorScale.ranges[opts.seriesIndex]
        const state = opts.seriesIndex == 0 ? 'block' : 'none'
        return `
        <div class="relative h-10 -mr-2 mt-5">
          <div class='relative w-14 h-5' style='background-color: ${range.color};'></div>
          <p class='absolute -left-1' style='display: ${state};'>0</p>
          <p class='absolute -right-2'>${range.to}</p>
        </div>`
      }
    },
    plotOptions: {
      heatmap: {
        colorScale: {
          ranges: []
        }
      }
    },
    colors: [],
    series: [],
    stroke: {},
    states: {
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none'
        }
      }
    },
    xaxis: {
      tooltip: {
        enabled: false
      }
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          colors: [],
          fontSize: '12px',
          cssClass: 'opacity-40'
        },
        formatter: function (value) {
          return value.toString()
        },
        offsetX: -5
      }
    },
    dataLabels: {
      enabled: false
    }
  } as ApexOptions

  setSeries(series: Array<{ name: string; data: [] }>): void {
    this.options.series = series
  }

  setColor(color: string[]): void {
    this.options.colors = color
  }

  setPlotRange(range: Array<{ from: number; to: number; name: string; color: string }>): void {
    this.options.plotOptions.heatmap.colorScale.ranges = range
  }

  setCategories(categories: string[]): void {
    this.options = {
      ...this.options,
      ...{
        xaxis: {
          ...this.options.xaxis,
          categories: categories
        }
      }
    }
  }
}

export { HeatmapChart }
